<mat-card>
	<mat-card-header>
		<mat-card-title>
			Confirming Update
			<button class="close-button" mat-mini-fab (click)="closeDialog(false)">
				<mat-icon>close</mat-icon>
			</button>
		</mat-card-title>
	</mat-card-header>

	<mat-dialog-content>
		<div *ngIf="!isLoading">
			<div class="margin-bottom-lg" *ngFor="let category of data.CATEGORIES; let i = index"
				[hidden]="!category.CHANGES || category.CHANGES.length === 0">
				<mat-card-title>
					{{category.CATEGORY}} ({{tableDataSources[i].data.length}})
				</mat-card-title>
				<mat-divider> </mat-divider>

				<div class="margin-top-md">
					<mat-table [dataSource]="tableDataSources[i]" class="table-responsive mat-elevation-z1" matSort>

						<ng-container matColumnDef="CHANGED_FIELD">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Field </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<div>
									{{element.CHANGED_FIELD}}
								</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="VALUE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Old Value </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<div>
									{{element.VALUE}}
								</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="CHANGED_VALUE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Modified Value </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<div>
									{{element.CHANGED_VALUE}}
								</div>
							</mat-cell>
						</ng-container>

						<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
						<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
					</mat-table>

				</div>
			</div>
		</div>

		<div>
			<button mat-raised-button color="primary" (click)="submit()" *ngIf="hasChanges && !isLoading">
				Save
			</button>

			<h2 *ngIf="!hasChanges && !isLoading">
				There are no changes &nbsp;
			</h2>

			<span class="align-btn">
				<button mat-raised-button color="primary" (click)="closeDialog(false)"
					*ngIf="!hasChanges && !isLoading">
					Go Back
				</button>
			</span>
		</div>
	</mat-dialog-content>
</mat-card>